import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './css/styleguide.css';

import LogPage from './pages/LogPage';
import CommunityPage from './pages/CommunityPage';
import HomePage from './pages/HomePage';
import HotTopicsPage from './pages/HotTopicsPage';
import MyJoyNetPage from './pages/MyJoyNetPage';
import ProfilePage from './pages/ProfilePage';
import OtherUserProfilePage from './pages/OtherUserProfilePage';
import TimelinePage from './pages/TimelinePage';
import MessagesPage from './pages/MessagesPage';
import OneMoreStep from './pages/OneMoreStep';
import TestPage from "./pages/TestPage";
import SignUpPage from './pages/SignUpPage';
import OnboardingPage from './pages/OnboardingPage';
import ProtectedRoute from './components/ProtectedRoute';

import { UserProvider } from './context/UserContext';

const theme = createTheme({
  palette: {
    mode: 'light',
  },
});

/* This is the main App component. It is used to define the pages for the website. */

export default function App() {
  return (
    <UserProvider>   
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            } />
            <Route path="/community" element={
              <ProtectedRoute>
                <CommunityPage />
              </ProtectedRoute>
            } />
            <Route path="/hottopics" element={
              <ProtectedRoute>
                <HotTopicsPage />
              </ProtectedRoute>
            } />
            <Route path="/messages" element={
              <ProtectedRoute>
                <MessagesPage />
              </ProtectedRoute>
            } />
            <Route path="/myjoynet" element={
              <ProtectedRoute>
                <MyJoyNetPage />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/profile/:userId" element={
              <ProtectedRoute>
                <OtherUserProfilePage />
              </ProtectedRoute>
            } />
            <Route path="/onboarding" element={
              <ProtectedRoute>
                <OnboardingPage />
              </ProtectedRoute>
            } />
            <Route path="/justonemorestep" element={
              <ProtectedRoute>
                <OneMoreStep />
              </ProtectedRoute>
            } />

            {/* ROUTES THAT NEED TO BE ADDED */}
            <Route path="/timeline/:profile_id" element={<TimelinePage />} />

            {/* AUTH NOT REQUIRED */}
            <Route path="/login" element={<LogPage />} />
            <Route path="/signup" element={<SignUpPage />} />

            {/* TESTING */}
            <Route path="/test" element={<TestPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </UserProvider>
  );
}
